<template>
  <div class="card p-2">
    <div class="card-header">
      <h6 class="card-title">Video Delete</h6>
    </div>
    <div class="card-body">
      <div class="item-status">
        <div
          class="item-status__body d-flex align-items-center justify-content-between"
        >
          <div
            class="btn btn-sm btn-outline--danger w-100"
            role="button"
            @click.prevent="handleShowModalDelete"
          >
            <i class="fa fa-trash mr-2"></i>
            Delete
          </div>
        </div>
      </div>
    </div>
    <deleteModal
      @handleRemovedItem="deleteItem"
      :key="item_id"
    />
  </div>
</template>

<script>
import axios from 'axios';
import deleteModal from './delete-modal.vue';

export default {
  name: 'delete-item',
  components: { deleteModal },
  props: {
    item_id: {
      type: Number | String,
      required: true,
    },
    redirectRoute: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showDeleteModal: false,
    };
  },
  mounted(){
    this.showDeleteModal = false;
  },

  methods: {
    async deleteItem() {
      try {
        const response = await axios.delete(
          '/creator/flix-playlist/item/disable?item_id=' + this.item_id,
        );
        if (response.data.success) {
          this.showDeleteModal = false;
          window.location = this.redirectRoute;
        }
        notify('success', response.data.message);
      } catch (error) {
        console.log(error);
        notify('error', error.response.data.message);
      }
    },
    handleShowModalDelete() {
      $('#deleteItemModal').modal('show');
    },
  },
};
</script>
